import { minifyString } from './index.js';

/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-var */
/* eslint-disable one-var */
/* eslint-disable vars-on-top */
/* eslint-disable func-style */
/* eslint-disable func-names */
/* eslint-disable prefer-template */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable prefer-rest-params */
/* eslint-disable object-shorthand */
/* eslint-disable no-useless-return */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
const defineGtmCode = function (w, d, s, l, i) {
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.defer = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
};
const defineGTM = (options, dataLayer) => {
    const { id = 'GTM-PMDFG9' } = options;
    const response = [`(${defineGtmCode.toString()})(window,document,'script','${dataLayer}','${id}')`];
    return minifyString(response.join(';\n'));
};

export { defineGTM };
//# sourceMappingURL=gtm.js.map
